import client from './client';

export const contactAPI = {
  submitMessage: (data) => client.post('/contact', data)
};
